import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import { applyDisplayRuntimeProfileToDocument } from './config/displayRuntime';

import '@styles/main.scss';
// import { ModalContextProvider } from '@contexts/ModalContext';

applyDisplayRuntimeProfileToDocument();

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);
const queryClient = new QueryClient();
document.addEventListener("contextmenu", (e) => {
  e.preventDefault();
});
root.render(
  <QueryClientProvider client={queryClient}>
    {/* <ModalContextProvider> */}
      <App />
    {/* </ModalContextProvider> */}
  </QueryClientProvider>
);

// root.render(
//   <QueryClientProvider client={new QueryClient()}>
//     <App />
//   </QueryClientProvider>,
// );

// calling IPC exposed from preload script
// window.electron.ipcRenderer.once('ipc-example', (arg) => {
//   // eslint-disable-next-line no-console
//   console.log(arg);
// });
// window.electron.ipcRenderer.sendMessage('ipc-example', ['ping']);
